import AvatarPlaceHolder from "./avatar-placeholder.png";
import DeleteIcon from "./delete-icon.PNG";
import Google from "./icon_google.png";
import ImageComboPromo from "./image-combo-promo.png";
import ImageGroupSeller from "./image-group-seller.png";
import ImageTopSales from "./image-logo-top-sales.png";
import ImageOrderPromo from "./image-order-promo.png";
import ImageProductPromo from "./image-product-promo.png";
import ImageSellerVoucher from "./image-seller-voucher.png";
import ImageSpecificSeller from "./image-specific-seller.png";
import LockedIcon from "./locked-icon.PNG";
import PlaceholderImageFailed from "./Placeholder-image-failed.png";
import QuestionIcon from "./question-icon.png";
import SupportIcon from "./support-icon.png";
import UnlockedIcon from "./unlocked-icon.PNG";
import ImageCashDiscount from "./cash_discount.png";

const Img = {
  LockedIcon,
  UnlockedIcon,
  DeleteIcon,
  AvatarPlaceHolder,
  SupportIcon,
  PlaceholderImageFailed,
  QuestionIcon,
  Google,
  ImageTopSales,
  ImageComboPromo,
  ImageProductPromo,
  ImageOrderPromo,
  ImageGroupSeller,
  ImageSellerVoucher,
  ImageSpecificSeller,
  ImageCashDiscount
};

export default Img;
